import { render, staticRenderFns } from "./qrCode.vue?vue&type=template&id=204c0764&scoped=true"
import script from "./qrCode.vue?vue&type=script&lang=js"
export * from "./qrCode.vue?vue&type=script&lang=js"
import style0 from "./qrCode.vue?vue&type=style&index=0&id=204c0764&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204c0764",
  null
  
)

export default component.exports